export default __webpack_public_path__ + "static/media/catalogue-image.ed705a0a.jpg";